// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__7HavA","title":"BackImages_title__2otpG","images":"BackImages_images__1bO98"};